import compose from 'vegas-js-core/src/functors/compose'

import initApp from '../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import Authorities from '../Authorities'
import { styles }  from '../ThingChildren'

class Producer extends Authorities
{
    getLocale = () => this.props.locale.things.application.producer ;
}

Producer.defaultProps =
{
    ...Authorities.defaultProps ,
    member : 'producer'
};

Producer.propTypes =
{
    ...Authorities.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )(Producer) ;